var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-card-text"},[_c('v-col',[_c('p',[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }